var map = {
	"./AUD.png": "6da9",
	"./CAD.png": "4905",
	"./CHF.png": "fba8",
	"./CHN.png": "5c13",
	"./DKK.png": "ed78",
	"./EUR.png": "952e",
	"./FSCL.png": "b02a",
	"./Finsia.png": "01c5",
	"./GBP.png": "1cfb",
	"./HKD.png": "f6a3",
	"./IE-Money-logo-white.png": "3efb",
	"./JPY.png": "da00",
	"./NOK.png": "63ee",
	"./NZD.png": "883b",
	"./SEK.png": "3ccd",
	"./SGD.png": "e722",
	"./USD.png": "cd4c",
	"./ZAF.png": "e4f2",
	"./acams.png": "ed22",
	"./business.png": "3597",
	"./cfcs.png": "1826",
	"./chineseFlag.png": "be98",
	"./england.png": "e0da",
	"./financial_service.png": "26d4",
	"./group-150x150.png": "c688",
	"./hk.png": "1934",
	"./ica.png": "e13e",
	"./icon_tab@2x.png": "a867",
	"./img_about.png": "8527",
	"./img_productDisplay.png": "bb57",
	"./individual-150x150.png": "4334",
	"./logo_poli.png": "df80",
	"./long_logo.png": "faf0",
	"./newFSCL.png": "26b4",
	"./newzealand.png": "d977",
	"./square_logo.png": "8aee",
	"./taiwhenua.png": "abdd",
	"./visa_rupay.png": "c68b",
	"./w_fscl.png": "1524",
	"./w_taiwhenua.png": "3270",
	"./white_long_logo.png": "d8d5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b967";